import React, { Component } from 'react';
import classNames from 'classnames/bind';
import styles from './TeacherInfo.scss';

class TeacherInfo extends Component {
  render() {
    const cx = classNames.bind(styles);
    const { teacherData, initModal } = this.props;
    // console.log(teacherData.data.clipDetail);
    return (
      <div className={cx('TeacherInfo')}>
        <div>
          <span className="close" onClick={initModal}></span>
        </div>
        <span className="name">{teacherData.data.teacherTitle}</span>
        <p>{teacherData.data.clipDetail}</p>
        <h5>강의 수 : {teacherData.data.lectureCount}강</h5>
      </div>
    );
  }
}

export default TeacherInfo;
